module.exports = __webpack_public_path__ + "static/media/Team 28 - Recycle4MarineLife.9ab383ca.png";